$(document).ready(function (){

    $("#add-author").on('click',function (e){
        $('#form-authors').trigger("reset");
        $('#form-update-authors').trigger("reset");
        $('.item-country').val('');
        $('.item-country').trigger("chosen:updated");

        $('.item-country_visible').val('');
        $('.item-country_visible').trigger("chosen:updated");

        $('.item-avatar').attr('src', '')
        $("#modal-author").modal('show')
    })

    $("#form-authors").on('submit',function (e){
        e.preventDefault()
        $(".loader_").addClass("loading")
        let data = new FormData(this)
        sendData(data, '/admin/add-author','new')
    })

    $("#form-update-authors").on('submit',function (e){
        e.preventDefault()
        $(".loader_").addClass("loading")
        let data = new FormData(this)
        sendData(data, '/admin/update-author','update')
    })

    function sendData(data, route,action) {
        $.ajax({
            url: route,
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (data.type == "success") {
                        if (action == "update") {
                            $('#form-update-authors').trigger("reset");
                            $('.item-avatar').attr('src', '')
                            $(".item-id").val('')
                            $("#search-author").val('')
                        }
                        alertSuccess(data.msg)
                        $("#modal-author").modal("hide")
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)

            },
            error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                /*var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });*/
            }
        })
    }
})
